import { clsx } from 'clsx';

interface AlbumArtworkProps {
  src: string | null;
  alt: string;
  className?: string;
}

export const AlbumArtwork = ({ src, alt, className }: AlbumArtworkProps) => {
  if (!src) {
    return <div className={clsx('bg-gray-200 dark:bg-gray-700', className)} />;
  }

  return (
    <div className={clsx('relative overflow-hidden', className)}>
      <img src={src} alt={alt} className="h-full w-full object-cover" />
    </div>
  );
}; 